import React, { useState, useEffect } from "react";
import { Container, Row, Col } from "react-bootstrap"; 

import * as apiUrl from "../../apiUrl";

function BecomeAgentDescription() {

    const [BecomeAgentDescription, setBecomeAgentDescription] = useState([]);

    useEffect(() => {
        const fetchBecomeAgentDescription = async () => {
          try {
            const response = await fetch(
              apiUrl.apiUrl + `/api/become-agent/brokers-network-section`
            );
            if (!response.ok) {
              throw new Error("Failed to fetch data");
            }
            const data = await response.json();
            setBecomeAgentDescription(data);
          } catch (error) {
            console.error("Error fetching data:", error);
          }
        };
    
        fetchBecomeAgentDescription();
      }, []);
    

    return (
            <section className='latest-blog-sec'>
                <Container fluid>
                    <Row className='flex-center latest-blog-content-row'>
                        <Col md={6} className='padding-zero'>
                            <div className='latest-blog-content-div' data-aos="fade-right">
                                <h2 className='common-head greyColor'>{BecomeAgentDescription.section_title}
                                </h2>
                                <p className='common-para'>{BecomeAgentDescription.section_description}​</p>
 
                            </div>
                        </Col>
                        <Col md={6} className='padding-zero'>                            
                                <img
                                    src={`${apiUrl.apiUrl}/${BecomeAgentDescription.section_image}`}
                                    className="img-fluid"
                                    alt="Marquis Property Developers"
                                    data-aos="fade-left"
                                />                            
                        </Col>
                    </Row>

                </Container>
            </section>
    );
}

export default BecomeAgentDescription;